import { Button, Container, TextField, Typography, Divider, Box, Backdrop, CircularProgress } from "@mui/material";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Context } from "../../App";
import GoogleLoginButton from "../ui/GoogleLoginButton";
import { useTheme } from "@mui/material/styles";

export default function LoginForm({ onLogin }) {
    const [mail, setMail] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [msg, setMessage] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const { setIsConnected, setUserId } = useContext(Context);
    const theme = useTheme();
    const navigate = useNavigate();

    const handleGoogleSuccess = (userData) => {
        console.log('Google authentication successful:', userData);
        
        // Stocker les informations utilisateur
        localStorage.setItem('token', userData.token); // Nom cohérent avec App.js
        localStorage.setItem('userData', JSON.stringify(userData.user));
        localStorage.setItem('user', userData.user._id); // ID utilisateur
        
        // Mettre à jour le contexte
        setIsConnected(true);
        setUserId(userData.user._id);
        
        // Rediriger vers l'accueil ou le formulaire d'info complémentaire si nécessaire
        const user = userData.user;
        console.log('User data for completeness check:', user); // Debug
        const requiredFields = ['genre', 'nom', 'prenom', 'mail', 'zip_code', 'ville'];
        const hasAllInfo = requiredFields.every(field => {
            const value = user[field];
            if (value === null || value === undefined) return false;
            // Pour les strings, vérifier qu'elles ne sont pas vides après trim
            if (typeof value === 'string') return value.trim() !== '';
            // Pour les autres types (comme les nombres), vérifier qu'ils existent
            return value !== '' && value !== 0;
        });
        console.log('User has all required info:', hasAllInfo); // Debug
        const redirectPath = hasAllInfo ? '/' : '/info_complementaire';
        console.log('Navigating to:', redirectPath); // Debug
        navigate(redirectPath);
    };

    const handleGoogleError = (error) => {
        console.error('Google authentication failed:', error);
        // Gérer l'erreur (affichage notification, etc.)
    };

    const handleClassicLogin = async () => {
      setMessage('');
      setLoading(true);

      fetch(`${process.env.REACT_APP_ESDRAS_API_URL}/auth/login`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic ' + btoa(mail+':'+password),
        }
      })
      .then(async response => {
          const token = response.headers.get('x-auth-token');
          if (token) localStorage.setItem('token', token);
          if (!response.ok) {
              const errorMessage = await response.text();
              setMessage(errorMessage || 'Erreur lors de la connexion');
          }else {
              const token = response.headers.get('x-auth-token');
              if (token) localStorage.setItem('token', token);
              const json = await response.json();
              if(!!json && typeof json === 'object') {
                localStorage.setItem('user', JSON.stringify(json._id));
                localStorage.setItem('userData', JSON.stringify(json));
                setUserId(json._id);
                setIsConnected(true);
              }
              onLogin()
          }
          setLoading(false);
      })
      .catch(error => {
          setLoading(false);
          console.error('Erreur lors de la connexion :', error);
          alert('Une erreur est survenue. Veuillez réessayer plus tard.');
      });
    };

    return <Container maxWidth="sm" sx={{ display:'flex', flexDirection:'column', mt: 4, rowGap:4, minWidth: '400px' }}>
        <Typography variant="h4" align="center" >Je me connecte</Typography>
        {msg && <Typography variant="body2" color="error" align="center">{msg}</Typography>}

        {/* Connexion classique */}
        <Box component={'form'} display="flex" flexDirection="column" gap={2} onSubmit={(e) => { e.preventDefault(); handleClassicLogin(); }}>
          <TextField fullWidth label="Adresse e-mail" variant="outlined" value={mail} required
          onChange={(e) => setMail(e.target.value)} />

          <TextField fullWidth type="password" label="Mot de passe" variant="outlined" value={password} required
          onChange={(e) => setPassword(e.target.value)} />
          
          <a href="/forgot_password" style={{ alignSelf: 'flex-end', color: theme.palette.primary.main }}>
            <Typography variant="body2" color="primary">Mot de passe oublié ?</Typography>
          </a>

          <Button variant="contained" type="submit" sx={{alignSelf: 'center', px: 5}}>
            Connexion
          </Button>
          
          <a href="/register" style={{ textDecoration: 'none' }}><Typography variant="body2" color="primary">Pas encore de compte ? Inscrivez-vous</Typography></a>
        </Box>


        <Divider sx={{ }}>
          <Typography variant="body2" color="text.secondary">
            Ou connectez-vous avec
          </Typography>
        </Divider>

        {/* Connexion Google */}
        <GoogleLoginButton 
          onSuccess={handleGoogleSuccess}
          onError={handleGoogleError}
        />
      <Backdrop open={loading} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}><CircularProgress color="inherit" /></Backdrop>
    </Container>
}